import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=4f267f06&scoped=true"
import script from "./PlotList.vue?vue&type=script&lang=ts"
export * from "./PlotList.vue?vue&type=script&lang=ts"
import style0 from "./PlotList.vue?vue&type=style&index=0&id=4f267f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f267f06",
  null
  
)

export default component.exports